import React from 'react';
import { Button } from 'react-bootstrap';

import "./JSONEditor.scss";

const JSONEditor = ({ json, setJson }) => {

    const handleKeyChange = (id, newkey) => {
        const index = json?.findIndex(e => e.id == id);
        if (index >= 0) {
            const newJSONArray = [...json];
            newJSONArray[index].key = newkey;
            setJson(newJSONArray);
        }
    } 

    const handleValueChange = (id, newValue) => {
        const index = json?.findIndex(e => e.id == id);
        if (index >= 0) {
            const newJSONArray = [...json];
            newJSONArray[index].value = newValue;
            setJson(newJSONArray);
        }
    } 

    const handleDeleteEntry = (id) => {
        const newJSONArray = json?.filter(e => e.id !== id);
        setJson(newJSONArray);
    } 

    const handleAddEntry = () => {
        const newJSONArray = [...json];
        const maxId = json?.length > 0 ? Math.max(...json.map(obj => obj.id)) : 0;
        newJSONArray.push({ id: maxId + 1, key: 'entree' + maxId, value: "" });
        setJson(newJSONArray);
    }

    const jsonDisplay = Object.fromEntries(json.map(({ key, value }) => [key, value]));

    return (
        <div className='json-editor'>
            <div className="json-form">
                {json.map(entry => (
                    <div key={entry.id} className='entry-zone'>
                        <label>Clé:</label>
                        <input
                            type="text"
                            value={entry.key}
                            onChange={e => handleKeyChange(entry.id, e.target.value)}
                            className='mr-4'
                        />
                        <label>Valeur:</label>
                        <textarea
                            value={entry.value}
                            onChange={e => handleValueChange(entry.id, e.target.value)}
                            className='mr-4'
                        />
                        <Button variant="danger" sisze="sm" className="p-2" onClick={() => handleDeleteEntry(entry.id)}>X</Button>
                </div>
            ))}
                <Button variant='light' onClick={handleAddEntry}>+ Ajouter une entrée</Button>
            </div>
            <div className="json-preview">
                <pre>{JSON.stringify(jsonDisplay, null, 2)}</pre>
            </div>
        </div>
    );
};




export default JSONEditor